import { configureStore } from '@reduxjs/toolkit';
import user from './user/reducers';
import documents from './documents/reducers';
import recordTables from './recordTables/reducers';
import forms from './forms/reducers';
import organizations from './organizations/reducers';
import obligations from './obligations/reducers';
import internalObligations from './internalObligations/reducers';
import laws from './laws/reducers';
import reports from './reports/reducers';

export const store = configureStore({
  reducer: {
    user,
    documents,
    forms,
    organizations,
    obligations,
    internalObligations,
    laws,
    // recordTables,
    reports,
  },
});
